import CategoriesTypeTable from "./components/CategoriesTypeTable";

const CategoriesTypeComponent = () => {
  return <CategoriesTypeTable />;
};
export default CategoriesTypeComponent;
